import { useState, useEffect, useContext } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PageNavbarDoctor } from "./page-navbar-doctor";
import { PageSidebarDoctor } from "./page-sidebar-doctor";
import { GlobalContext } from "../../context/Provider";
import { getDoctorState } from "../../context/actions/auth/getDoctorState";
import { useNavigate } from "react-router-dom";
import { logoutDoctor } from "../../utils";
import { getDecryptedDataFromSessionStorage } from "../../utils";
import { SECRET_KEY } from "../../constants/encriptKey";

const PageLayoutRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 64,
  [theme.breakpoints.up("lg")]: open
    ? {
        paddingLeft: 280,
      }
    : {
        paddingLeft: 65,
      },
}));

export const PageLayoutDoctor = (props) => {
  const { children } = props;
  const { userState, setUserState } = useContext(GlobalContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarPersistentOpen, setSidebarPersistentOpen] = useState(false);
  const navigate = useNavigate();

  const allowedStates = ["1", "0", "2"];

  useEffect(() => {
    //const token = localStorage.getItem("token");
    const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
    const { token } = data;
    if (token) {
      getDoctorState({ token: token.toString() })
        .then((response) => {
          setUserState(response.estado);
          if (!allowedStates.includes(response.estado)) {
            if (response.estado === "3" || response.estado === "4") {
              logoutDoctor();
              navigate("/");
            } else {
              navigate("/dashboard");
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      navigate("/");
    }
  }, [userState]);

  return (
    <>
      <PageLayoutRoot open={isSidebarPersistentOpen}>
        <Box
          sx={{
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {children}
        </Box>
      </PageLayoutRoot>
      <PageNavbarDoctor
        onSidebarOpen={() => setSidebarOpen(true)}
        onSidebarPersistentOpen={() =>
          setSidebarPersistentOpen(!isSidebarPersistentOpen)
        }
        openPersistent={isSidebarPersistentOpen}
      />
      <PageSidebarDoctor
        onClose={() => setSidebarOpen(false)}
        open={isSidebarOpen}
        openPersistent={isSidebarPersistentOpen}
        status={userState}
      />
    </>
  );
};
